// NPM import
import React, { Fragment, useState } from "react";
import { Button } from "../../revvComponents";

// Component Import
import { UpgradePopUpV2 } from "../../commonComponents";
import PlanChangeRequest from "../SettingsWrapper/BillingSettings/PlanChangeRequest";

// Internal Import
import { GlobalUtils } from "../../utils";
import { IMAGE_URLS } from "../../constants";
import { buttonClickEvent } from "../../gtm/gtmutils";
import GTM_EVENTS from "../../gtm/gtmevents";

// Destructuring
const { isFreeBillingPlan, readDataFromLocalStorage, checkFreePlan } =
  GlobalUtils;
const { STAR } = IMAGE_URLS;

// Declarations
const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
const currentPlan = userSignUpInfo && userSignUpInfo.billing_plan;

function PlanUpgrade(props) {
  const [popupOpen, setPopupOpen] = useState(false);
  const user = readDataFromLocalStorage("userSignUpInfo");
  let showUpgradeBtn = props.showOnlyOnFreePlan ? isFreeBillingPlan() : true;
  if (showUpgradeBtn && props.planType) {
    showUpgradeBtn = !checkFreePlan(props.planType);
  }

  const _setUpgradePopup = flag => {
    buttonClickEvent(GTM_EVENTS.UPGRADE_CLICK);
    setPopupOpen(flag);
  };
  if (
    showUpgradeBtn &&
    ((user && Object.keys(user).length > 0) || props.isSharedDocument)
  ) {
    return (
      <Fragment>
        {props.isSharedDocument ? (
          <Button
            className="planupgrade-recipient-btn"
            data-test="planupgrade-recipient-btn"
            onClick={() => {}}>
            <img src={STAR} alt="star" />
            <span className="planupgrade-btn-txt">Contact sender for use</span>
          </Button>
        ) : (
          <Button
            className={`planupgrade-btn ${
              props.templateBtn ? "planupgrade-btn-template" : ""
            } ${props.onlyIcon ? "planupgrade-only-icon" : ""}  ${
              props.smallBtn ? "small-btn" : ""
            }`}
            data-test="planupgrade-btn"
            onClick={() => _setUpgradePopup(true)}>
            <img src={STAR} alt="star" width="20px" height="20px" />
            <span className="planupgrade-btn-txt">Upgrade</span>
          </Button>
        )}

        {(popupOpen || props.showPopUp) &&
          (isFreeBillingPlan() ? (
            <UpgradePopUpV2
              type={props.type || "generic"}
              currentPlan={user.billing_plan} // Remove this prop from here & add on dynamic place selection injection
              onClose={() => {
                setPopupOpen(false);
                if (props.onClose) {
                  props.onClose(false);
                }
              }}
            />
          ) : (
            <PlanChangeRequest
              currentPlan={currentPlan}
              onClose={() => {
                setPopupOpen(false);
                if (props.onClose) {
                  props.onClose(false);
                }
              }}
            />
          ))}
      </Fragment>
    );
  }

  return null;
}

export default PlanUpgrade;
